export default "__VITE_ASSET__uSU1ZpyX__"